import styled from "@emotion/styled";
import { CheckboxFormControl } from "@kaltura/ds-react-components";
import { formControlLabelClasses } from "@mui/material";
import { KmsTypeFilterItemCheckbox } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { ChangeEvent } from "react";
import { FilterItemAdditionalProps } from "./FilterItemAdditionalProps";

export type CheckboxFilterItemProps = KmsTypeFilterItemCheckbox & FilterItemAdditionalProps;

const StyledCheckboxFilterItem = styled("div")(({ theme }) => ({
    marginTop: 0,
    marginBottom: theme.spacing(2),
    [`& .${formControlLabelClasses.label} p`]: { fontSize: 14 },
}));

/**
 * checkbox filter item - a single (controlled)checkbox in a filter
 */
export function CheckboxFilterItem(props: CheckboxFilterItemProps) {
    const sendButtonAnalytics = useButtonAnalytics();
    const { label, param, value, checked = false, equalsAll = false, onChange, disabled = false } = props;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (equalsAll && !event.target.checked) {
            // equalsAll cant be unchecked manually
            return;
        }
        const eventName = `Filters - ${param} - ${value} - ${event.target.checked ? "Checked" : "Unchecked"} `;
        sendButtonAnalytics(eventName, ButtonClickAnalyticsType.FILTER);
        onChange(param, value, event.target.checked, equalsAll);
    };

    return (
        <StyledCheckboxFilterItem className="kms-ds-checkbox-filter-item">
            <CheckboxFormControl
                label={label}
                value={value}
                disabled={disabled}
                checked={checked}
                onChange={handleChange}
            />
        </StyledCheckboxFilterItem>
    );
}

export default CheckboxFilterItem;
